module.exports = __webpack_public_path__ + "img/inprogress.6822277d.svg";